import {createProvider} from "../../base/helpers/createContext";

export const ImportContext = createProvider({});
